import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { sendBirdSelectors, useSendbirdStateContext } from '@sendbird/uikit-react';
import { find } from 'lodash';

// Reports the other member of the open channel. Renders nothing, and needs the SendbirdProvider,
// so the parent mounts it only once Sendbird is ready.
const ActiveChannelUser = ({ channelUrl, onChange }) => {
  const [channel, setChannel] = useState(null);
  const store = useSendbirdStateContext();
  const sdk = sendBirdSelectors.getSdk(store);

  useEffect(() => {
    let mounted = true;
    (async () => {
      if (!sdk || !channelUrl) return;
      const ch = await sdk.groupChannel.getChannel(channelUrl);
      if (mounted) setChannel(ch);
    })();
    return () => {
      mounted = false;
    };
  }, [sdk, channelUrl]);

  useEffect(() => {
    if (channel) {
      const user = find(channel.members, x => x.userId !== store.config.userId);

      if (user) {
        onChange({ uuid: user.userId, name: user.nickname });
      }
    }
  }, [channel]); // eslint-disable-line

  return null;
};

ActiveChannelUser.propTypes = {
  channelUrl: PropTypes.string,
  onChange: PropTypes.func.isRequired
};

export default ActiveChannelUser;
